import React from 'react'
import Base from './base'
import TextRender from './text/block'
import RichTextRender from './rich-text/block'
import MediaRender from './media/block'
import BooleanRender from './boolean'
import DefaultRender from './default'
import GisRender from './gis/block'
import UserRender from './user'
import SelectRender from './select'
import RefRender from './ref/block'
import StatisticsRender from './statistics/block'

const renders = {
  default: DefaultRender,
  text: TextRender,
  richText: RichTextRender,
  media: MediaRender,
  boolean: BooleanRender,
  gis: GisRender,
  user: UserRender,
  select: SelectRender,
  ref: RefRender,
  statistics: StatisticsRender,
}

const Render = function ({ value, defs, rowData, fields, className, hooks }) {
  return (
    <Base
      value={value}
      defs={defs}
      rowData={rowData}
      fields={fields}
      className={className}
      hooks={hooks}
      renders={renders}
    />
  )
}

export default React.memo(Render)
